import {render} from "inferno";
import {App} from "./App";
import "./resources/css/bootstrap.css";
import "./resources/css/main.css";
//import {initDevTools} from 'inferno-devtools';

(window as any).debugAnimations = true;
const container = document.getElementById("cvc-app");
//initDevTools();
render(<App/>, container);
